import { Button, Spinner } from "@shapr3d/frontend-lib";
import { InfoBar } from "@shapr3d/frontend-lib";

import useAccount from "../../hooks/useAccount";
import type { Subscription } from "../../hooks/useAccountTypes";
import { SubscriptionType } from "../../types";
import { calculateDaysLeft } from "../../utils/convertUtils";

import style from "./GracePeriodBanner.module.css";

export interface GracePeriodBannerProps {
  paymentInfoUpdate: (s: Subscription) => void;
  paymentInfoUpdatePending: boolean;
}

export const GracePeriodBanner: React.FC<GracePeriodBannerProps> = ({
  paymentInfoUpdate,
  paymentInfoUpdatePending,
}) => {
  const { data: accountData } = useAccount();

  if (!accountData?.subscriptionInGracePeriod?.gracePeriodExpirationDate) {
    return null;
  }

  const gracePeriodDaysLeft = calculateDaysLeft(
    accountData.subscriptionInGracePeriod?.gracePeriodExpirationDate,
    new Date()
  );
  const title = `Payment error - ${gracePeriodDaysLeft} day${
    gracePeriodDaysLeft === 1 ? "" : "s"
  } left in grace period`;

  const gracePeriodExpirationDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(accountData.subscriptionInGracePeriod.gracePeriodExpirationDate);

  const pendingPaymentInfoUpdate =
    accountData.subscriptionInGracePeriod.type !== SubscriptionType.Chargebee &&
    paymentInfoUpdatePending;

  return (
    <InfoBar
      className={style.banner}
      title={title}
      text={
        <>
          {`Update your payment method to prevent losing access to paid features. Your subscription will be automatically switched to Basic on `}
          <b>{`${gracePeriodExpirationDate}`}</b>
        </>
      }
      variant="critical"
      cta={
        <Button
          variant="grayscale"
          onClick={() => {
            if (accountData.subscriptionInGracePeriod) {
              paymentInfoUpdate(accountData.subscriptionInGracePeriod);
            }
          }}
          disabled={pendingPaymentInfoUpdate}
        >
          {pendingPaymentInfoUpdate ? <Spinner size={18} /> : "Update"}
        </Button>
      }
    ></InfoBar>
  );
};
